import TopicPage from './TopicPage';

export default TopicPage;
